import * as React from 'react'
import { BaseCompositionProps } from '../types'

export interface KratosProps extends BaseCompositionProps {
    mainContent: React.ReactElement<any>
}

export const Kratos: React.FC<KratosProps> = ({ mainContent }) => {
    return <>{mainContent}</>
}
